import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PortalShell } from "@/components/portal/PortalShell";
import { useBranding } from "@/context/BrandingContext";

export default function PrivacyPage() {
  const { config } = useBranding();
  const sections = [
    ["Controlador e operador", `Este serviço é operado por ${config?.org_name} (${config?.operator_document}). Contato: ${config?.operator_contact}.`],
    ["Dados coletados", "CNPJ da empresa, nome do responsável, telefone com DDD, melhor horário para contato e número da agência (4 dígitos) e número da conta. Não coletamos senhas bancárias, tokens, códigos de autenticação ou dados de cartão."],
    ["Finalidade", "Identificar a solicitação de atendimento, apresentar informações de pontuação quando disponíveis e realizar o contato para agendamento de resgate."],
    ["Base legal", "Consentimento do titular e execução de procedimentos preliminares solicitados pelo titular (art. 7º, I e V, da LGPD)."],
    ["Retenção", `Os dados são mantidos por até ${config?.retention_days || 180} dias e então excluídos automaticamente, salvo obrigação legal de guarda.`],
    ["Seus direitos", "Você pode solicitar confirmação, acesso, correção, anonimização ou exclusão dos seus dados, bem como revogar o consentimento, pelo contato do operador informado acima."],
    ["Segurança", "Conexões criptografadas (HTTPS), acesso restrito a operadores autenticados e registro de auditoria de todas as ações."],
  ];
  return (
    <PortalShell>
      <article className="glass-card w-full max-w-3xl p-8 sm:p-12" data-testid="privacy-page">
        <Link to="/" className="mb-6 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-slate-200" data-testid="privacy-back-link"><ArrowLeft className="h-4 w-4" /> Voltar</Link>
        <h1 className="font-display text-3xl text-slate-50 sm:text-4xl">Política de privacidade</h1>
        <div className="mt-8 space-y-7">
          {sections.map(([t, c]) => (
            <section key={t}>
              <h2 className="text-base font-semibold md:text-lg" style={{ color: "var(--brand)" }}>{t}</h2>
              <p className="mt-2 leading-relaxed text-slate-300">{c}</p>
            </section>
          ))}
        </div>
      </article>
    </PortalShell>
  );
}
